/**
 * `/buddy`: the AI Buddy module (boards P, Q, R): the trainer's conversations with Buddy, and the
 * one that is open. Entered from the MoveBuddy mark at the top of the navigation.
 *
 * One route for every conversation, the open one named in the search (`?rozmowa=`), so stepping
 * between conversations keeps the history rail mounted. The slice owns its search parameters.
 */

import { createFileRoute } from '@tanstack/react-router';

import { AiPlanBuilderScreen, validateAiPlanBuilderSearch } from '~/pages/ai-plan-builder';

export const Route = createFileRoute('/_shell/buddy')({
  validateSearch: validateAiPlanBuilderSearch,
  component: AiPlanBuilderScreen,
});
